/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
/*!*********************************!*\
  !*** ./src/assets/js/footer.js ***!
  \*********************************/
var docReady = function docReady(fn) {
  // see if DOM is already available
  if (document.readyState === "complete" || document.readyState === "interactive") {
    // call on next available tick
    setTimeout(fn, 1);
  } else {
    document.addEventListener("DOMContentLoaded", fn);
  }
};

docReady(function () {
  var titles = document.querySelectorAll(".footer__menu-title");

  if (titles) {}

  var _loop = function _loop(i) {
    // onClick on title, expand footer links
    titles[i].addEventListener("click", function () {
      // select sibling element of title
      var sibling = titles[i].nextElementSibling;
      var collapse = sibling.querySelector(".collapsible-links");
      titles[i].classList.toggle("active");
      collapse.classList.toggle("collapse");
    });
  };

  for (var i = 0; i < titles.length; i++) {
    _loop(i);
  }
});
/******/ })()
;